import React, { Component, } from 'react';
import IndividualFilter from "../filters-type/individualFilter.component.jsx";
import GlobalHelper from "../../GlobalHelper.jsx";
import DebounceInput from "react-debounce-input";
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
    "close": {
        id: "common.search_filter.btn.close",
        defaultMessage: "Close",
    },
    "modal_header": {
        id: "common.search_filter.modal.modal_header",
        defaultMessage: "More Filters",
    },
    "search_placeholder": {
        id: "common.search_filter.modal.search_placeholder",
        defaultMessage: "Search...",
    },
})


class FilterListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalName: "invoice",
            filters: props.filters,
            filterSearch: "",
            renderElem: props.filters,
            filtersToUse: props.filtersToUse,
            dateSelect: false,
            filterInfo: props.savedFilter,
        }

        this.dateSelected = this.dateSelected.bind(this);
        this.onChangeFilterFilters = this.onChangeFilterFilters.bind(this)
        this.onChangeAllValues = this.onChangeAllValues.bind(this)
    }


    onChangeFilterFilters(event) {
        var valueSearch = event.target.value
        if (valueSearch !== "" && valueSearch) {
            var filteredFilters = this.state.filters.filter((elem) => {
                if (elem.section === undefined) {
                    return elem.label.toUpperCase().indexOf(valueSearch.toUpperCase()) !== -1;
                } else {
                    return false;
                }
            })
            if (filteredFilters) {
                this.setState({ filterSearch: valueSearch, renderElem: filteredFilters })
            }
        } else {
            this.setState({ filterSearch: "", renderElem: this.state.filters })
        }
    }

    onChangeAllValues(operation, elemId, value, label, op) {
        let newFiltersToUse = Object.assign(this.state.filtersToUse);
        if (operation === 'remove') {
            delete newFiltersToUse[elemId]
        } else if (operation === 'add') {
            newFiltersToUse[elemId] = { nameId: elemId, value: value, label: label, op: op }
        }
        this.setState({
            filtersToUse: newFiltersToUse
        })
        this.props.onChangeFilter(newFiltersToUse)
    }

    dateSelected() {
        this.setState({ dateSelect: !this.state.dateSelect })
    }

    render() {
        const filters= this.state.renderElem.filter((filter) => (
            (filter.nameId !== 'locationId' || filter.nameId === 'locationId' && GlobalHelper.canEditLocation()))
        )

        return (
            <div className="modal-content search-content">
                <div className="modal-header">
                    <div className="h5 modal-title">
                        <span>{this.props.intl.formatMessage(messages["modal_header"])}</span>
                    </div>
                </div>
                <div className='w-100'>
                    <DebounceInput
                        onKeyPress={this.props.onKeyPress}
                        minLength={0}
                        debounceTimeout={500}
                        autoComplete={this.props.autoComplete}
                        name={this.props.name}
                        onChange={this.onChangeFilterFilters}
                        id={this.props.id}
                        value={this.state.filterSearch}
                        type="search"
                        className="form-control rounded-0"
                        placeholder={this.props.intl.formatMessage(messages["search_placeholder"])}
                    />
                </div>

                <div className="modal-body search-modal py-0 overflow-auto" id="result">
                    <div className="d-flex flex-column">
                        
                        <div className="panel-group" id={this.state.modalName} role="presentation" aria-multiselectable="true">
                            {filters
                                .map((filter) => (
                                    (this.state.filterSearch === '' && filter.section !== undefined) ?
                                        <div key={filter.section + 'section'} className='ml-2 mt-4'>
                                            <p className='font-weight-bold mb-0'>{filter.section}</p>
                                        </div> :
                                        <IndividualFilter
                                            key={filter.nameId + "filter"}
                                            filter={filter}
                                            filterTagLabel={!(filter.nameId in this.state.filtersToUse) ? "" : this.state.filtersToUse[filter.nameId].label}
                                            filterOperation={!(filter.nameId in this.state.filtersToUse) ? filter.initialSelect : this.state.filtersToUse[filter.nameId].op}
                                            value={!(filter.nameId in this.state.filtersToUse) ? filter.initialValue : this.state.filtersToUse[filter.nameId].value}
                                            isUsed={filter.nameId in this.state.filtersToUse}
                                            parentName={this.state.modalName}
                                            onDateSelected={this.dateSelected}
                                            onChangeValues={this.onChangeAllValues}
                                        /> 
                                )
                            )}
                       </div>
                    </div>
                    <div className='dateHeight'></div>
                </div>
                <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.onCloseModal}>{this.props.intl.formatMessage(messages["close"])}</button>
                </div>
            </div>

        );
    }
}
export default injectIntl(FilterListModal);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-menu/filterListModal.component.jsx